//export const authAdoUsername =  "oyvindh";
//export const authAdoPassword =  "";

export const authAdoUsername =  "";
export const authAdoPassword =  "";

export const authJiraUsername =  "testtest";
export const authJiraPassword =  "2QqQD5x7bW";
